import { Code2, Eye, MessageSquare, PanelRightClose, PanelRightOpen, Search } from 'lucide-react';

export default function SessionViewControls({ideMode, setIdeMode, outputsCollapsed, toggleOutputs, previewPanelOpen, togglePreviewPanel, onSearch}) {
  return (
            <div className="flex shrink-0 items-center gap-1">
              {!ideMode && <button type="button" className="workbench-icon" aria-label="Buscar nesta conversa" title="Buscar nesta conversa" onClick={onSearch}><Search size={16} /></button>}
              <div className="flex h-9 shrink-0 items-center rounded-lg border border-apolo-border/70 bg-apolo-surface2/70 p-0.5 lg:h-8" role="group" aria-label="Visualização da sessão">
                <button
                  type="button"
                  onClick={() => setIdeMode(false)}
                  aria-pressed={!ideMode}
                  aria-label="Abrir chat do Code"
                  title="Chat do Code"
                  className={`inline-flex h-8 items-center justify-center gap-1.5 rounded-md px-2 text-xs font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accent/50 motion-reduce:transition-none lg:h-7 ${!ideMode ? 'bg-apolo-surface1 text-apolo-textPrimary shadow-sm' : 'text-apolo-textTertiary hover:bg-apolo-surface3 hover:text-apolo-textPrimary'}`}
                >
                  <MessageSquare size={14} aria-hidden="true" />
                  <span className="hidden xl:inline">Chat</span>
                </button>
                <button
                  type="button"
                  onClick={() => setIdeMode(true)}
                  aria-pressed={ideMode}
                  aria-label="Abrir editor de código"
                  title="Editor de código"
                  className={`inline-flex h-8 items-center justify-center gap-1.5 rounded-md px-2 text-xs font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accent/50 motion-reduce:transition-none lg:h-7 ${ideMode ? 'bg-apolo-surface1 text-apolo-textPrimary shadow-sm' : 'text-apolo-textTertiary hover:bg-apolo-surface3 hover:text-apolo-textPrimary'}`}
                >
                  <Code2 size={14} aria-hidden="true" />
                  <span className="hidden xl:inline">Editor</span>
                </button>
              </div>
              <button
                type="button"
                onClick={toggleOutputs}
                aria-pressed={!outputsCollapsed}
                aria-label={outputsCollapsed ? 'Abrir Saídas, Canvas e Menu' : 'Fechar painel de saídas'}
                title="Painel · Tasks · Saídas · Canvas · Menu"
                className={`hidden shrink-0 items-center justify-center rounded-md transition focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accent/50 motion-reduce:transition-none lg:inline-flex lg:h-7 lg:w-7 ${!outputsCollapsed ? 'bg-apolo-surface3 text-apolo-textPrimary' : 'text-apolo-textTertiary hover:bg-apolo-surface2 hover:text-apolo-textPrimary'}`}
              >
                {outputsCollapsed ? <PanelRightOpen size={16} aria-hidden="true" /> : <PanelRightClose size={16} aria-hidden="true" />}
              </button>
              <button
                type="button"
                onClick={togglePreviewPanel}
                aria-pressed={!!previewPanelOpen}
                aria-label={previewPanelOpen ? 'Fechar preview de design' : 'Abrir preview de design (app ao vivo)'}
                title="Design · preview ao vivo"
                className={`hidden shrink-0 items-center justify-center rounded-md transition focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accent/50 motion-reduce:transition-none lg:inline-flex lg:h-7 lg:w-7 ${previewPanelOpen ? 'bg-apolo-surface3 text-apolo-textPrimary' : 'text-apolo-textTertiary hover:bg-apolo-surface2 hover:text-apolo-textPrimary'}`}
              >
                <Eye size={16} aria-hidden="true" />
              </button>
            </div>
  );
}
